import ApiERP from '@/core/conectores/ApiERP';
import { IRetornoRelatorio } from '@/core/models/IRetornoRelatorio';
import { IRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import { ISimulacaoProducao } from '@/models/Entidades/PCP/ISimulacaoProducao';
import { ISimulacaoProducaoItem } from '@/models/Entidades/PCP/ISimulacaoProducaoItem';
import { ISimulacaoProducaoNecessidade } from '@/models/Entidades/PCP/ISimulacaoProducaoNecessidade';

class ServicoPCP {
  endPoint = 'pcp-simulacao-producao';

  apiERP = new ApiERP();

  public requisicaoSistema(): void {
    this.apiERP = new ApiERP(true);
  }

  public async explodirNecessidades(
    empresa: number,
    itens: ISimulacaoProducaoItem[],
    profundidadeTotal: boolean,
    tipoProducaoPI?: number,
  ): Promise<ISimulacaoProducaoNecessidade[]> {
    const queryTipoProducaoPI = tipoProducaoPI !== undefined ? `&tipoProducaoPI=${tipoProducaoPI}` : '';
    const result: any = await this.apiERP.post(`${this.endPoint}/explodir-necessidades/empresa/${empresa}?profundidadeTotal=${profundidadeTotal}${queryTipoProducaoPI}`, itens);
    return result.data;
  }

  public async incluirSimulacao(simulacao: ISimulacaoProducao): Promise<IRetornoRequisicao> {
    const result: any = await this.apiERP.post(`${this.endPoint}`, simulacao);
    return result.data;
  }

  public async obterSimulacaoPorCodigo(codigo: number, empresa: number): Promise<ISimulacaoProducao> {
    const result: any = await this.apiERP.get(`${this.endPoint}/${codigo}/empresa/${empresa}`);
    return result.data;
  }

  public async alterarSimulacao(simulacao: ISimulacaoProducao): Promise<IRetornoRequisicao> {
    const result: any = await this.apiERP.put(`${this.endPoint}`, simulacao);
    return result.data;
  }

  public async obterListaSimulacao(empresa: number): Promise<ISimulacaoProducao[]> {
    const result: any = await this.apiERP.get(`${this.endPoint}/lista/empresa/${empresa}`);
    return result.data;
  }

  public async excluirSimulacao(codigo: number): Promise<IRetornoRequisicao> {
    const result: any = await this.apiERP.delete(`${this.endPoint}/${codigo}`);
    return result.data;
  }

  public async imprimirSimulacao(codigo: number, empresa: number): Promise<IRetornoRelatorio> {
    const result: any = await this.apiERP.get(`${this.endPoint}/${codigo}/empresa/${empresa}/impressao`);
    return result.data;
  }
}
export default ServicoPCP;
